import type { Ref } from 'react'
import { forwardRef } from 'react'

import clsx from 'clsx'

import '@hotmart/cosmos/dist/form/form.css'
import '@hotmart/cosmos/dist/form/input-default.css'
import '@hotmart/cosmos/dist/form/input-validate.css'
import '@hotmart/cosmos/dist/form/variations/large.css'
import '@hotmart/cosmos/dist/form/variations/small.css'

import type { TextFieldProps } from './types'

const TextField = (
  { name, className = '', size = 'md', hasError = false, ...rest }: TextFieldProps,
  ref: Ref<HTMLInputElement>
) => {
  const inputClass = clsx(
    'hot-form__input',
    { 'is-invalid': hasError, [`hot-form__input--${size}`]: size },
    className
  )

  return <input ref={ref} name={name} className={inputClass} {...rest} />
}

export default forwardRef(TextField)
